<script setup lang="ts" generic="T extends string | number | boolean | object">
withDefaults(
  defineProps<{
    label: string;
    value?: T;
    dense?: boolean;
  }>(),
  {
    dense: false,
    value: undefined,
  },
);
</script>

<template>
  <li class="tw-block">
    <label
      class="tw-block tw-font-bold tw-uppercase tw-text-gp-rhino"
      :class="{
        'tw-mb-0 tw-text-xs': dense,
        'tw-mb-2': !dense,
      }"
    >
      {{ label }}
    </label>
    <slot>
      <span>{{ value }}</span>
    </slot>
  </li>
</template>

<style scoped></style>
